import styled from 'styled-components'
import { Paper } from '@material-ui/core'
import { StyledH1, StyledH4, theme } from '../../../theme/Global'

export const LatestUpdatesContainer = styled(Paper)`
  box-shadow: unset;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
`

export const UpdateCounter = styled(StyledH1)`
  color: ${theme.colors.redText};
`

export const StateList = styled(StyledH4)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  margin-left: 2.5rem;
  margin-right: 2.5rem;
  margin-top: 0.5rem;
`

export const StateName = styled.div`
  font-size: 16px;
  margin-left: 5px;
  color: ${theme.colors.text}
`

export const MonthYear = styled(StyledH4)`
  margin-top: 1rem;
`
